import { TextField, Autocomplete } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useSelectedOption from '../../../../../../../../../utils/hooks/useSelectedOption';
import { groupsCustom } from '../../../../../../../../../utils/custom_prop_types/customPropTypes';

export default function ProductAssociationSelect({
  selectedProductAssociation,
  associationGroups,
  setSelectedProductAssociation,
}) {
  const [associationsArray, setAssociationsArray] = useState([]);
  const selectedOption = useSelectedOption(associationsArray, selectedProductAssociation);

  const handleProductAssociationSelectChange = (association) => {
    const groupIRI = association.iri;
    const groupNumber = association.description;
    const groupProducts = association.products;
    setSelectedProductAssociation({ groupIRI, groupNumber, groupProducts });
  };

  useEffect(() => {
    setAssociationsArray([]);

    associationGroups.all['hydra:member']?.forEach((group) => (
      setAssociationsArray((prevState) => [...prevState,
        {
          description: group.number,
          firstProduct: group.products[0]?.description,
          compare: group['@id'],
          iri: group['@id'],
          products: group.products,
        }])
    ));
  }, [associationGroups]);

  return (
    <Autocomplete
      autoHighlight
      disableClearable
      options={associationsArray}
      value={selectedOption}
      getOptionLabel={(option) => `${option.description} (${option.firstProduct})`}
      onChange={(_, value) => handleProductAssociationSelectChange(value)}
      renderInput={(params) => (
        <TextField
          color="primary"
            // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
          label="Pick Association"
        />
      )}
    />
  );
}

ProductAssociationSelect.propTypes = {
  selectedProductAssociation: PropTypes.shape({
    groupIRI: PropTypes.string.isRequired,
    groupNumber: PropTypes.string.isRequired,
    groupProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  }).isRequired,
  associationGroups: groupsCustom.isRequired,
  setSelectedProductAssociation: PropTypes.func.isRequired,
};
